import React from "react";
import CheckBox from "../Checkbox/Checkbox";
import styles from "./styles.module.scss";

export default function OptIn({ isChecked, setIsChecked }) {
	return (
		<div className={styles.optIn}>
			<CheckBox isChecked={isChecked} onChange={setIsChecked} name="opt-in" />
			<small>
				<strong>Opt-in to receive SMS, emails, and phone calls.</strong>
				By clicking “Opt-In,” you expressly consent to receive calls and text
				messages for marketing purposes from MyAccident.org, our affiliates, and
				<a href="https://myaccident.org/partner-attorneys" target="_blank">
					{" marketing partners "}
				</a>
				using automated technology including artificial/pre-recorded voice. You
				agree that we may contact you at any time, including before 8am or after
				9pm local. Consent is not a condition of purchase. You agree to the use
				of electronic signatures, our{" "}
				<a href="https://myaccident.org/privacy-policy" target="_blank">
					{" Privacy Policy"}
				</a>
				, and{" "}
				<a href="https://myaccident.org/terms-of-use" target="_blank">
					{" Terms of Use."}
				</a>
			</small>
		</div>
	);
}
